import { render, staticRenderFns } from "./ClaimingTricksButton.vue?vue&type=template&id=3fabf301&scoped=true&"
import script from "./ClaimingTricksButton.vue?vue&type=script&lang=js&"
export * from "./ClaimingTricksButton.vue?vue&type=script&lang=js&"
import style0 from "./ClaimingTricksButton.vue?vue&type=style&index=0&id=3fabf301&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fabf301",
  null
  
)

export default component.exports